import * as types from '../types';
import { IRecurringPresetsApi } from '../contracts';
import { HttpApi } from './HttpApi';

type Res<T> = types.APIResponse<T>;

export class RecurringPresetsHttpApi extends HttpApi implements IRecurringPresetsApi {
  async listRecurringPresets(active?: boolean): Promise<types.RecurringPreset[]> {
    const params = active === undefined ? undefined : { active: String(active) };
    return (await this.http.get<Res<types.RecurringPreset[]>>('/recurring-presets', { params })).data.data;
  }

  async getRecurringPreset(id: string): Promise<types.RecurringPreset> {
    return (await this.http.get<Res<types.RecurringPreset>>(`/recurring-presets/${encodeURIComponent(id)}`)).data.data;
  }

  async createRecurringPreset(data: types.CreateRecurringPresetRequest): Promise<types.RecurringPreset> {
    return (await this.http.post<Res<types.RecurringPreset>>('/recurring-presets', data)).data.data;
  }

  async updateRecurringPreset(id: string, data: types.UpdateRecurringPresetRequest): Promise<types.RecurringPreset> {
    return (await this.http.patch<Res<types.RecurringPreset>>(`/recurring-presets/${encodeURIComponent(id)}`, data)).data.data;
  }

  async deleteRecurringPreset(id: string): Promise<void> {
    await this.http.delete(`/recurring-presets/${encodeURIComponent(id)}`);
  }
}
